import React, { useContext, useEffect, useState } from "react";
import { TopLoaderContext } from "../../../context/TopLoader";
import { DatePicker, Form, Input, Select, Checkbox, Skeleton } from "antd";
import RadioGroup from "../../atoms/RadioGroup";
import SelectAddress from "../SelectAddress";
import { Country, State, City } from "country-state-city";
import Button from "../../atoms/Button";
import ProjectDeveloperDetails from "./ProjectDeveloperDetails";
import ProponentDetails from "./ProponentDetails";
import CategoryAndSubCategory from "./CategoryAndSubCategory";
import { ReactComponent as DownIcon } from "../../svgs/dropdown_icon.svg";
import ValidationBody from "./ValidationBody";
import VerifierBody from "./VerifierBody";
import SdgContribution from "../../atoms/SdgContribution";
import DocumentRequired from "./DocumentRequired";
import { getAllCategories } from "../../../utils/API/getAllCategories";
import { getAllRegistries } from "../../../utils/API/getAllRegistries";
import { getProjectDetails } from "../../../utils/API/getprojectDetails";
import { getAllVerificationBodies } from "../../../utils/API/getAllVerificationBodies";
import {
  documentsValidator,
  formDataTransform,
} from "../../../utils/helper/project-upload-form";
import { uploadProject } from "../../../utils/API/uploadProject";
import toast from "react-hot-toast";
import AcceptPopUp from "../AcceptPopUp";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  populateData,
  populateDocs,
} from "../../../utils/helper/auto-filled-data";
import ProjectCommunication from "../../atoms/ProjectCommunication";
import { useLocation } from "react-router-dom";
import { Tooltip } from "antd";

const { TextArea } = Input;

const dateFormatList = ["DD/MM/YYYY", "DD-MM-YYYY"];

const defaultDocumentsState = {
  project_design: [],
  legal_compliance: [],
  environmental_impact_assessment: [],
  issuance_representation: [],
  monitoring_report: [],
  verification_report: [],
  validation_report: [],
  proof_of_validation_contraction: [],
  validation_representation: [],
  issuance_report: [],
  SDG_certification: [],
  project_video: [],
  listing_representation: [],
  evidence_project_ownership: [],
  registration_representation: [],
  verification_representation: [],
  project_images: [],
};

const ProjectUploadForm = () => {
  const dispatch = useDispatch();
  const { loadingRef } = useContext(TopLoaderContext);
  const [form] = Form.useForm();
  const [sameAsAbove, setSameAsAbove] = useState(false);
  const [SDG_selected, setSDG_selected] = useState([]);
  const [categories, setCategories] = useState([]);
  const [registries, setRegistries] = useState([]);
  const [selectedRegistry, setSelectedRegistry] = useState(null);
  const [otherRegistry, setOtherRegistry] = useState("");
  const [showOtherInput, setShowOtherInput] = useState(false);
  const [verificationBodies, setVerificationBodies] = useState([]);
  const [documents, setDocuments] = useState(defaultDocumentsState);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [projectDetails, setProjectDetails] = useState(null);
  const navigate = useNavigate();
  const { id: projectId } = useParams();
  const [editable, setEditable] = useState(projectId ? true : false);
  const action = projectId;
  const location = useLocation();
  const [customInput, setCustomInput] = useState("");
  const [verifiercustomInput, setVerifierCustomInput] = useState("");

  const { fromProjectsPage } = location.state || {};

  const onSameAsAbove = (value) => {
    setSameAsAbove(value);
  };

  const [showEndDate, setShowEndDate] = useState(false);
  const inputClass = "border-0 border-b-2 rounded-none";

  useEffect(() => {
    try {
      const fetchCategories = async () => {
        setLoading(true);
        const promise1 = getAllCategories(dispatch);
        const promise2 = getAllRegistries(dispatch);
        const promise3 = getAllVerificationBodies(dispatch);
        const promises = [promise1, promise2, promise3];
        if (projectId) {
          const promise4 = getProjectDetails(projectId, dispatch);
          promises.push(promise4);
        }
        const data = await Promise.all(promises);
        setLoading(false);
        setCategories(data[0]);
        setRegistries([
          ...data[1].map(({ _id, registryName }) => {
            return { value: _id, label: registryName };
          }),
        ]);
        setVerificationBodies(
          data[2]
            .map(({ _id, name }) => {
              return { value: _id, label: name };
            })
            .concat({ value: "others", label: "Others" })
        );

        if (projectId) {
          setProjectDetails(data[3].data);
        }
      };
      fetchCategories();
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  }, [projectId, dispatch]);


  useEffect(() => {
    if(sameAsAbove){
      setVerifierCustomInput(customInput);
    }
  },[customInput , sameAsAbove]);

  const handleOtherRegistryChange = (e) => {
    const formattedValue = e.target.value;
    setOtherRegistry(formattedValue);
  };

  useEffect(() => {
    if (sameAsAbove) {
      const data = form.getFieldValue("validation_body");
      form.setFieldsValue({ verifier_body: data });
    }
  }, [sameAsAbove, form]);

  useEffect(() => {
    if (projectId && projectDetails) {
      populateData(projectDetails, form, verificationBodies, registries);
      setSDG_selected(projectDetails.SDG_contribution);
      const uploadedDocs = populateDocs(projectDetails.project_documents);
      setDocuments(uploadedDocs);

      // Check if the pre-filled registry is "Others" and show input if true
      if (projectDetails.registry_name._id === "66c5d22b1d15ff403f019546") {
        setShowOtherInput(true);
        setOtherRegistry(projectDetails.others_registry_name);
      } else {
        setShowOtherInput(false);
      }

      setTimeout(() => {
        form.setFieldValue(
          "subcategory_id",
          projectDetails.category.subcategory_id._id
        );
        form.setFieldValue("state", projectDetails.location.state_code);
      }, 1000);
    }
  }, [projectDetails, projectId, form, verificationBodies, registries]);

  const onValidatorChange = () => {
    if (sameAsAbove) {
      const data = form.getFieldValue("validation_body");
      form.setFieldsValue({ verifier_body: data });
    }
  };

  const onSubmit = async (data) => {
    const missingFields = documentsValidator(documents);

    if (showOtherInput && otherRegistry) {
      // Set `others_registry_name` with manually inputted value
      data.others_registry_name = otherRegistry;
      // Ensure `registry_name` does not have the manually entered value
      data.registry_name = "66c5d22b1d15ff403f019546"; // or another appropriate value representing "Others"
    } else {
      // Set `registry_name` with the selected registry ID
      data.registry_name = selectedRegistry;
    }

    if (missingFields.length > 0) {
      // Customize error message based on missing fields
      if (missingFields.includes("project_images")) {
        toast.error("Upload at least 4 Project images");
      } else {
        toast.error(`Please upload ${missingFields[0]} `);
      }
      return;
    }

    const transformedData = formDataTransform(
      data,
      verificationBodies,
      registries
    );

    transformedData.validation_body = transformedData.validation_body.map(
      (item, index) => {
        if (item.organisation_name === "Others") {
          item.organisation_name = customInput[index] || "Others"; // Use custom input or default to "Others"
        }
        return item;
      }
    );

    transformedData.verifier_body = transformedData.verifier_body.map(
      (item, index) => {
        if (item.organisation_name === "Others") {
          item.organisation_name = verifiercustomInput[index] || "Others"; // Use custom input or default to "Others"
        }
        return item;
      }
    );

    transformedData.SDG_contribution =
      SDG_selected.length > 0 ? SDG_selected : "";

    // if (SDG_selected.length < 1) {
    //   toast.error("Select at least one SDG");
    //   return;
    // }

    const documentsTransformedData = Object.entries(documents)
      .filter(([key, value]) => Array.isArray(value) && value.length > 0) // Only include keys where documents exist and ensure value is an array
      .reduce((acc, [key, value]) => {
        acc[key] =
          value.length === 1 ? value[0].url : value.map((item) => item.url);
        return acc;
      }, {});

    try {
      loadingRef.current.continuousStart();
      await uploadProject(
        {
          ...transformedData,
          SDG_contribution: SDG_selected,
          project_documents: documentsTransformedData,
        },
        dispatch
      );
      setSuccess(true);
      form.resetFields();
      setSDG_selected([]);
      setSameAsAbove(false);
      setDocuments(defaultDocumentsState);
    } catch (err) {
      toast.error(err.message);
    }
    loadingRef.current.complete();
  };

  const onFinishFailed = (errorInfo) => {
    form.scrollToField(errorInfo.errorFields[0].name);
  };

  return (
    <div className="bg-gray-100 w-full h-full p-6">
      <div className="text-2xl font-bold mb-4">
        {editable ? "View Project" : "Upload New Projects"}
      </div>
      <div className="w-full pl-8 pr-8 bg-white rounded-2xl shadow-formShadow pb-12 h-[calc(100vh-6rem)] overflow-y-scroll no-scrollbar">
        <Form
          onFinish={onSubmit}
          onFinishFailed={onFinishFailed}
          form={form}
          noValidate
          onValuesChange={onValidatorChange}
          initialValues={{
            proponents_details: [{}],
            project_developer_details: [{}],
            registry_name: selectedRegistry,
            validation_body: [{}],
            verifier_body: [{}],
          }}
          className="offset-form font-spaceGrotesk"
          disabled={editable}
        >
          <div className="pr-44">
            <h3 className="text-2xl font-medium text-[#252525] mb-2 mt-4">
              Project details
            </h3>
            <Form.Item
              name="registry_name"
              label="Registry Name"
              rules={[
                {
                  required: true,
                  message: "Please select one option",
                },
              ]}
              labelCol={{ span: 24 }}
            >
              {loading ? (
                <Skeleton.Input active={true} size={"large"} block={true} />
              ) : (
                <RadioGroup
                  options={registries}
                  // onChange={handleRegistryChange}
                  onChange={(e) => {
                    if (e.target.value === "66c5d22b1d15ff403f019546") {
                      setShowOtherInput(true);
                    } else {
                      setShowOtherInput(false);
                      setSelectedRegistry(e.target.value);
                    }
                  }}
                  className="font-medium text-2xl max-w-4xl"
                />
              )}
            </Form.Item>
            {showOtherInput && (
              <Form.Item
                name="others_registry_name"
                label="Enter Registry Name"
                rules={[
                  { required: true, message: "Please enter the registry name" },
                ]}
              >
                <Input
                  placeholder="Enter registry name"
                  onChange={handleOtherRegistryChange}
                  className={inputClass}
                  // value={otherRegistry}
                />
              </Form.Item>
            )}

            <Form.Item
              label="Project ID"
              className="font-normal w-96"
              name="project_id"
              rules={[
                {
                  required: true,
                  message: "Please enter project id",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
            >
              <Input className={inputClass} />
            </Form.Item>

            <Form.Item
              label={"Proponent/Operator details"}
              labelCol={{ span: 24 }}
              required
            >
              <ProponentDetails Country={Country} />
            </Form.Item>

            <Form.Item
              label={"Project Developer"}
              labelCol={{ span: 24 }}
              required
            >
              <ProjectDeveloperDetails Country={Country} />
            </Form.Item>

            <div className="flex">
              <Form.Item
                label="About Project"
                className="font-normal w-1/2 text-area"
                name="about_project"
                rules={[
                  {
                    required: true,
                    message: "Please write about project",
                  },
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 22 }}
              >
                <TextArea
                  showCount
                  maxLength={600}
                  className="border-2 focus-within:shadow-none rounded-lg"
                  style={{ height: 116, resize: "none" }}
                />
              </Form.Item>

              <Form.Item
                label="Project Impacts and Benefits"
                className="font-normal w-1/2 text-area"
                name="project_impact_and_benefits"
                rules={[
                  {
                    required: true,
                    message: "Please write about project impacts and benefits",
                  },
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
              >
                <TextArea
                  showCount
                  maxLength={600}
                  className="border-2 focus-within:shadow-none rounded-lg"
                  style={{ height: 116, resize: "none" }}
                />
              </Form.Item>
            </div>

            <div className="w-[70%]">
              <CategoryAndSubCategory
                initialCategory={projectDetails?.category?.category_id}
                form={form}
                setCategories={setCategories}
                categories={categories}
              />
            </div>

            <div className="w-[60%]">
              <SelectAddress
                form={form}
                initialCountry={projectDetails?.location}
                label="Location Details"
                stateName={{
                  country: "country",
                  state: "state",
                }}
                Country={Country}
                State={State}
                City={City}
                requireAddressLine={false}
                requireCity={false}
                requirePincode={false}
              />
            </div>

            <div className="flex w-[70%] gap-x-12">
              <Form.Item
                name={"start_date"}
                label="Project Start Date"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please select date",
                  },
                ]}
              >
                <DatePicker
                  className={`p-1 w-44 ${inputClass}`}
                  format={dateFormatList}
                />
              </Form.Item>

              <Form.Item
                name={"project_registration_date"}
                label="Project Registration Date"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please select date",
                  },
                ]}
              >
                <DatePicker
                  className={`p-1 w-44 ${inputClass}`}
                  format={dateFormatList}
                />
              </Form.Item>
            </div>

            <Form.Item
              name={"project_issuance_date"}
              label="Credit Issuance Date"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Please select date",
                },
              ]}
            >
              <DatePicker
                className={`p-1 w-44 ${inputClass}`}
                format={dateFormatList}
              />
            </Form.Item>

            <div className="flex w-[70%] gap-x-12">
              <Form.Item
                name={"projectStillGoingOn"}
                label="Is project Still Ongoing?"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please select one option",
                  },
                ]}
              >
                <RadioGroup
                  onChange={(e) => setShowEndDate(!e.target.value)}
                  options={[
                    { label: "Yes", value: true },
                    { label: "No", value: false },
                  ]}
                  className="font-medium"
                />
              </Form.Item>

              {showEndDate && (
                <Form.Item
                  name={"end_date"}
                  label="Project End Date"
                  labelCol={{ span: 24 }}
                  wrapperCol={{ span: 24 }}
                  rules={[
                    {
                      required: true,
                      message: "Please select date",
                    },
                  ]}
                >
                  <DatePicker
                    className={`p-1 w-44 ${inputClass}`}
                    format={dateFormatList}
                  />
                </Form.Item>
              )}
            </div>

            <div className="flex gap-x-4">
              <Form.Item
                className="w-52"
                name={"crediting_period"}
                label="Crediting Period"
                rules={[
                  {
                    required: true,
                    message: "Please select crediting period",
                  },
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 22 }}
              >
                <Select
                  showSearch
                  optionFilterProp="label"
                  className="primary_variant"
                  suffixIcon={
                    <DownIcon className="w-[11px] h-[5px] text-[#808080]" />
                  }
                  placeholder={"Select"}
                  options={Array.from({ length: 100 }, (_, index) => ({
                    label: index + 1,
                    value: index + 1,
                  }))}
                />
              </Form.Item>

              <Form.Item
                name={"project_scale"}
                label="Project Scale"
                className="w-60"
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 24 }}
                rules={[
                  {
                    required: true,
                    message: "Please select one option",
                  },
                ]}
              >
                <RadioGroup
                  options={[
                    {
                      label: (
                        <Tooltip title="Less than or equal to 300,000 tonnes of CO2e per year">
                          <span className="font-medium hover:text-blue-500 transition-colors">
                            Projects
                          </span>
                        </Tooltip>
                      ),
                      value: "projects",
                    },
                    {
                      label: (
                        <Tooltip title="Greater than 300,000 tonnes of CO2e per year">
                          <span className="font-medium hover:text-blue-500 transition-colors">
                            Large Projects
                          </span>
                        </Tooltip>
                      ),
                      value: "large projects",
                    },
                  ]}
                  className="font-medium"
                />
              </Form.Item>

              <Form.Item
                name={"no_of_credits_on_registry"}
                label={"Total available Credits on Registry"}
                className="w-72"
                rules={[
                  {
                    required: true,
                    message: "Please enter",
                  },
                  {
                    pattern: /^[0-9]*$/,
                    message: "Invalid input",
                  },
                ]}
                labelCol={{ span: 24 }}
                wrapperCol={{ span: 12 }}
              >
                <Input className={inputClass} />
              </Form.Item>
            </div>

            <Form.Item
              name={"no_of_credits_on_offsetGo_marketPlace"}
              label={"No. of Credits want to list on OffsetGo marketplace"}
              rules={[
                {
                  required: true,
                  message: "Please enter",
                },
                {
                  pattern: /^[0-9]*$/,
                  message: "Invalid input",
                },
              ]}
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 4 }}
            >
              <Input className={inputClass} />
            </Form.Item>

            <Form.Item
              name={"type_of_credit"}
              label="Credit Type"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              rules={[
                {
                  required: true,
                  message: "Please select one option",
                },
              ]}
            >
              <RadioGroup
                options={[
                  { label: "Transferable", value: "transferable" },
                  {
                    label: "Non-Transferable/ Retirable",
                    value: "non-transferable",
                  },
                ]}
                className="font-medium"
              />
            </Form.Item>

            <Form.Item
              label="SDG Contribution"
              labelCol={{ span: 24 }}
              required
            >
              <SdgContribution
                selected={SDG_selected}
                setValue={setSDG_selected}
              />
            </Form.Item>

            <h5 className="text-2xl font-medium mb-6 pt-6">
              VVB (Validation/Verification Body)
            </h5>

            <ValidationBody
              Country={Country}
              registries={registries}
              verificationBodies={verificationBodies}
              customInput={customInput}
              setCustomInput={setCustomInput}
            />

            <VerifierBody
              Country={Country}
              onSameAsAbove={onSameAsAbove}
              sameAsAbove={sameAsAbove}
              registries={registries}
              verificationBodies={verificationBodies}
              editable={editable}
              customInput={verifiercustomInput}
              setCustomInput={setVerifierCustomInput}
              form={form}
            />
          </div>
          <h5 className="text-2xl font-medium mb-6 pt-6">Document Required</h5>
          <DocumentRequired documents={documents} setDocuments={setDocuments} />

          <Form.Item
            name="terms_and_condition"
            valuePropName="checked"
            className="mt-8"
            rules={[
              {
                required: true,
                message: "Please accept the terms and conditions.",
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject("Please accept the terms and conditions."),
              },
            ]}
            initialValue={projectId ? true : false}
          >
            <Checkbox>
              <p className="font-normal text-sm">
                Accept{" "}
                <span className="text-blue-800">
                  Terms & Conditions, Policies & terms of use{" "}
                </span>
                to proceed
              </p>
            </Checkbox>
          </Form.Item>
          {!fromProjectsPage && (
            <Button
              type="submit"
              color="blue"
              varient="primary"
              className="w-full h-12 px-16 mx-auto text-2xl text-white mt-12"
            >
              Submit
            </Button>
          )}
        </Form>

        {action && <ProjectCommunication projectDetails={projectDetails} />}

        <AcceptPopUp
          open={success}
          isRequiredColor={"green"}
          isRequiredCancelButton={false}
          okButtonText={"Go back"}
          title={"Project uploaded Successfully!"}
          onCancel={() => {
            setSuccess(false);
            navigate("/projects");
          }}
          onOk={() => navigate("/projects")}
        />
      </div>
    </div>
  );
};

export default ProjectUploadForm;
